import './AcRouteCellExpand.scss';
import { memo, useEffect, useRef, useState } from 'react';
import { Paper, Popper } from '@mui/material';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import {LAYOVERLIMIT} from '../../constants/bindings';
import { eventTransportationType } from '../../constants/myBlockMonth';
import { formatNumToTime } from '../../helpers/timeHelpers';

interface CellExpandProps {
  value: any;
  width: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      lineHeight: '24px',
      position: 'relative',
      width: '100%',

      '& .cellValue': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }
  })
);
const CellExpand = memo(function CellExpand(props: CellExpandProps) {
  const { width, value } = props;

  const cellDiv = useRef(null);
  const cellValue = useRef(null);
  const wrapper = useRef<HTMLDivElement | null>(null);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showFullCell, setShowFullCell] = useState(false);
  const [showPopper, setShowPopper] = useState(false);

  const classes = useStyles();
  const deadHeadIdentifier = 'DH';

  const handleMouseEnter = () => {   
    setShowPopper(true);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowPopper(false);
    setShowFullCell(false);
  };

  const handleKeyDown = (nativeEvent: KeyboardEvent) => {
    // IE11, Edge (prior to using Bink?) use 'Esc'
    if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
      setShowFullCell(false);
    }
  }

  useEffect(() => {
    if(!showFullCell) return undefined;
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);

  }, [setShowFullCell, showFullCell]);

  const routeComponent = (type) => {
    const deadHeadClassName = type === 'popover' ? 'AcRouteCellExpand__paper__dead-head' : 'dead-head dead-head--m';
    const layoverClassName = type === 'popover' ? 'AcRouteCellExpand__paper__layover' : 'layover';
    const redEyeClassName = type === 'popover' ? 'AcRouteCellExpand__paper__red-eye' : 'red-eye';
    return (
      value.row.flightSegments.map(s => (
        <>
          {s.segment.replace(s.deadheadAirports[0], `,${s.deadheadAirports[0]},`).split(',').map(f =>
            f.indexOf(s.deadheadAirports[0]) === -1 
              ? s.fltNo.includes(eventTransportationType.LIMO) 
                ? <><span className={deadHeadClassName}>{eventTransportationType.LIMO}</span> <span>{f.split(' ').slice(1).join(' ')}</span> </>
                : <span>{f}</span> 
              : <span className={deadHeadClassName}>{f.replace(deadHeadIdentifier,'')}</span>
          )}
          <span className={s.layOver < LAYOVERLIMIT ? layoverClassName : redEyeClassName}>{s.layOver ? ` (${formatNumToTime(s.layOver)}) ` : ''}</span>
        </>
      ))
    )
  }

  return (
    <div
      className={classes.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={wrapper}
    >
      <div
        ref={cellDiv}
        style={{
          display: 'block',
          height: 1,
          position: 'absolute',
          top: 0,
          width
        }}
      />
      <div className="cellValue" ref={cellValue}>
        <div className={value.row.isDeleted ? 'route pairing-list-row-opacity' : 'route'}>
          {routeComponent('standard')}
        </div>
      </div>
      {showPopper && (
        <Popper
          anchorEl={anchorEl}
          open={showFullCell && anchorEl != null}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            className={value.row.isDeleted ? 'AcRouteCellExpand__paper AcRouteCellExpand__paper__isDeleted' : value.row.isModified ? 'AcRouteCellExpand__paper AcRouteCellExpand__paper__isModified' : 'AcRouteCellExpand__paper'}
            elevation={3}
            style={{ minHeight: wrapper.current!.offsetHeight - 3, width: 260 }}
          >
            <div className="AcRouteCellExpand__paper__route">
              {routeComponent('popover')}
            </div>
          </Paper>
        </Popper>
      )}
    </div>
  );
});

export function AcRouteCellExpand(params: any) {
	return (
    <CellExpand
      value={params ? params : ""}
      width={params.colDef.width}
    />
  );
}

